import React, { useCallback, useEffect, useState } from 'react'
import DataTable from '../../../../app/components/statelessDataTable'
import createColumns from './columns'
import { paperStyles } from './styles'
import { handlePagination } from '../../../helpers'
import { concatenateAddress } from '../../../utils/addressUtilities'

const NotificationAddressModal = ({ isMinWage, notificationItem }) => {
  const [data, setData] = useState([])
  const [total, setTotal] = useState(0)
  const [pageNumber, setPageNumber] = useState(1)
  const [searchText, setSearchText] = useState('')
  const [sortOptions, setSortOptions] = useState({})
  const [filters, setFilters] = useState({ state: '' })
  const [filterOptions, setFilterOptions] = useState({
    filter: '',
    field: ''
  })
  const [loading, setLoading] = useState(false)

  const columns = createColumns({
    isMinWage,
    sortOptions,
    filterOptions,
    eventHandlers: {
      setSortOptions,
      setFilterOptions,
      setPageNumber
    }
  })
  const rowsPerPage = 10

  useEffect(() => {
    let subscribed = true
    if (subscribed) {
      setLoading(true)
      const locationsFiltered = notificationItem.locationsData.filter((location) => {
        const address = location.address ? parseLocationAddress(location.address) : ''
        return location.name.toLowerCase().includes(searchText.toLowerCase())
          || address.toLowerCase().includes(searchText.toLowerCase())
      })

      const paginatedLocations = handlePagination(locationsFiltered, rowsPerPage, pageNumber)

      setData(mapData(paginatedLocations))
      setTotal(locationsFiltered.length)
      setLoading(false)
    }
    return () => {
      subscribed = false
    }
  }, [pageNumber, filters, searchText, sortOptions, filterOptions])

  const handleChangePage = useCallback((event) => {
    setPageNumber(event.selected + 1)
    setData([])
  }, [])

  const handleSetSearchText = useCallback((value) => {
    setSearchText(value)
  }, [])

  const handleSetSortOptions = useCallback((value) => {
    setSortOptions(value)
  }, [])

  const handleSetFilters = (value) => {
    setFilters(value)
    setPageNumber(1)
  }

  const handleSetPageNumber = useCallback((value) => {
    setPageNumber(value)
  }, [])

  const mapData = (data) => {
    return data.map((row) => {
      const address = typeof row.address === 'string'
        ? row.address
        : concatenateAddress(row.address)
      return {
        ...row,
        address
      }
    })
  }

  return (
    <div style={!isMinWage ? paperStyles : null} data-testid="locations-affected-modal">
      <DataTable
        pageCount={Math.ceil(total / rowsPerPage)}
        isLoading={loading}
        recordType="Locations"
        showSearch
        showExport={false}
        showLocaleFilter={false}
        eventHandlers={{
          handleChangePage,
          setSearchText: handleSetSearchText,
          setSortOptions: handleSetSortOptions,
          setFilters: handleSetFilters,
          setPageNumber: handleSetPageNumber
        }}
        columns={columns}
        data={data}
        filters={filters}
        sortOptions={sortOptions}
        filterOptions={filterOptions}
        pageNumber={pageNumber}
        total={total}
        searchText={searchText}
        rowsPerPage={rowsPerPage}
      />
    </div>
  )
}

const parseLocationAddress = (address) => {
  return typeof address === 'string' ? address : concatenateAddress(address)
}

export default NotificationAddressModal
